<div class="px-4 px-md-5 px-xxl-4">
  <br>
  <div class="content-section">
    <br><br class="d-none d-md-block"><br class="d-none d-md-block">
    <div class="d-flex flex-column flex-lg-row content-nosotros">
      <div *ngFor="let type of nosotros" class="w-100">
        <div class="d-flex al-center pb-2 content-type">
          <img [src]="type.icon" class="me-3" alt="">
          <span class="text-blue fw-bold fs-4">{{type.title}}</span>
        </div>  
        <div class="my-3">
          <img [src]="type.image" class="w-100" alt="">
        </div>
        <div>
          <span class="fw-regular fs-5">{{type.description}}</span>
        </div>
      </div>
    </div>
    <br><br class="d-none d-md-block"><br class="d-none d-md-block">
  </div>
  <br><br><br>
</div>